module.exports = __webpack_public_path__ + "img/b4-3.6cb18e0.png";